import React from "react";
import EmptyQueryBoundary from "./EmptyQueryBoundary";
import CustomInfiniteHits from "./CustomInfiniteHits";
import useAlgoliaSearchInput from "@/hooks/search/useAlgoliaSearchInput";
import useAlgoliaSearchErrorHandler from "@/hooks/search/useAlgoliaSearchErrorHandler";

const Search = ({
  setIsSearching,
  ourSearchContainer,
  setQuery,
  inputValue,
  setInputValue,
  ourSearchInput,
  ourSearchButton,
}) => {
  useAlgoliaSearchInput(
    setIsSearching,
    ourSearchContainer,
    ourSearchInput,
    ourSearchButton,
    setQuery,
    inputValue,
    setInputValue
  );

  useAlgoliaSearchErrorHandler();

  // console.log('inputValue', inputValue)
  return (
    <EmptyQueryBoundary fallback={null}>
      <CustomInfiniteHits inputValue={inputValue} />
      <span className="w-full" id="TheMostImportantCatalogues"></span>
    </EmptyQueryBoundary>
  );
};

export default Search;
